import StatusTag from "common/Tags/StatusTag";
import React, { CSSProperties, useContext } from "react";
import { useAccountStatusTag } from "@shared/features/configuration/hooks";
import { AnalyticsPageName, ClientStatus } from "@shared/types";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";
import { DrawerContext } from "common/Drawers/Drawer.context.ts";
import { useTheme } from "styled-components";

interface AccountStatusTagProps {
  status: ClientStatus;
  style?: CSSProperties;
  withBgColor?: boolean;
  size?: "small";
  hideInstructions?: boolean;
}

const AccountStatusTag = ({
  status,
  style,
  withBgColor,
  size,
  hideInstructions,
}: AccountStatusTagProps) => {
  const { isDrawer } = useContext(DrawerContext) || {};
  const { isNewLook } = useTheme();
  const tagData = useAccountStatusTag(status, isDrawer, hideInstructions);

  const statusTag = (
    <StatusTag
      text={
        <>
          {tagData.tagText}
          {tagData.popoverContent && (
            <InfoCircleOutlined
              style={{
                marginLeft: 8,
                color: tagData.tagColor,
              }}
            />
          )}
        </>
      }
      color={tagData.tagColor}
      style={style}
      withBgColor={withBgColor || isDrawer}
      // Outside a drawer `isDrawer` is undefined, which StatusTag reads as its
      // default (animated). New look: only drawers pulse.
      animated={isNewLook ? !!isDrawer : isDrawer}
      size={size}
    />
  );

  if (tagData.popoverContent) {
    return (
      <HelperTooltip
        analyticsPageName={AnalyticsPageName.ACCOUNTS_AND_GROUPS}
        analyticsFieldName="Account Status"
        description={tagData.popoverContent}
        triggerElement={statusTag}
      />
    );
  }
  return statusTag;
};

export default AccountStatusTag;
